// eslint-disable-next-line
const styles = theme => ({
  root: {
    padding: 10
  },
  flexContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    height: "auto",
    minHeight: "100%"
  },
  pos: {
    width: "460px",
    margin: "10px",
    minHeight: "500px"
  },
  posContent: {
    minHeight: "100%",
    margin: "0 auto -130px;"
  },
  items: {
    flex: 1,
    margin: "20px",
    minWidth: "300px"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/sale/styles.js